import { useEffect } from 'react'

import { useAuthStateChange } from '@/modules/auth'
import { useAsyncError } from '@/modules/errors'
import {
  useFolder,
  useFoldersActions,
  useFoldersLoaders,
} from '@/modules/folders'
import { useProjectsStore } from '../stores'

export const useLoadingProjects = () =>
  useProjectsStore((state) => state.loadingProjects)

export const useProjectsMutating = () =>
  useProjectsStore((state) => state.mutating)

export const useProjects = () => useProjectsStore((state) => state.projects)

export const useArchivedProjects = () =>
  useProjectsStore((state) => state.archivedProjects)

export const useLoadingArchivedProjects = () =>
  useProjectsStore((state) => state.loadingArchivedProjects)

export const useProjectsActions = () =>
  useProjectsStore((state) => state.actions)

export const useProjectsMutations = () =>
  useProjectsStore((state) => state.mutations)

export const getProjectsMutations = () => useProjectsStore.getState().mutations

export const useProjectsLoaders = () =>
  useProjectsStore((state) => state.loaders)

export const useFetchProjects = (folderSlug?: string) => {
  const folder = useFolder()
  const folderLoaders = useFoldersLoaders()
  const { reset: resetFolders, setFolder } = useFoldersActions()
  const loaders = useProjectsLoaders()
  const { reset, startLoadingProjects } = useProjectsActions()
  const throwError = useAsyncError()

  useEffect(() => {
    if (folderSlug) {
      startLoadingProjects()
      folderLoaders.fetchFolder(folderSlug).catch(throwError)
    } else {
      setFolder(null)
      folderLoaders.fetchFolders('project').catch(throwError)
      loaders.fetchProjects().catch(throwError)
    }
  }, [])

  useEffect(() => {
    if (folderSlug && folder?.id) {
      loaders.fetchProjects(folder.id).catch(throwError)
    }
  }, [folder])

  useAuthStateChange({
    onSignedOut: () => {
      reset()
      resetFolders()
    },
  })
}

export const useFetchAllProjects = () => {
  const { fetchProjects } = useProjectsLoaders()
  const { reset } = useProjectsActions()
  const { reset: resetFolders, setFolder } = useFoldersActions()
  const throwError = useAsyncError()

  useEffect(() => {
    setFolder(null)
    fetchProjects(null, { allFolders: true }).catch(throwError)
  }, [])

  useAuthStateChange({
    onSignedOut: () => {
      reset()
      resetFolders()
    },
  })
}

export const useFetchArchivedProjects = () => {
  const { fetchArchivedProjects } = useProjectsLoaders()
  const { reset } = useProjectsActions()
  const { reset: resetFolders, setFolder } = useFoldersActions()
  const throwError = useAsyncError()

  useEffect(() => {
    setFolder(null)
    fetchArchivedProjects().catch(throwError)
  }, [])

  useAuthStateChange({
    onSignedOut: () => {
      reset()
      resetFolders()
    },
  })
}
